export enum ActionTypes {
    LOGOUT = "[App] logout",
};